/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1CourseCourseidChannelsChannelid200,
  PutApiV1CourseCourseidChannelsChannelid400,
  PutApiV1CourseCourseidChannelsChannelid401,
  PutApiV1CourseCourseidChannelsChannelid404,
  PutApiV1CourseCourseidChannelsChannelid500,
  PutApiV1CourseCourseidChannelsChannelidMutationRequest,
  PutApiV1CourseCourseidChannelsChannelidMutationResponse,
  PutApiV1CourseCourseidChannelsChannelidPathParams,
} from "../../types/courseChannelsController/PutApiV1CourseCourseidChannelsChannelid.ts";
import { channelDetailViewModelSchema } from "../channelDetailViewModelSchema.ts";
import { upsertChannelRequestViewModelSchema } from "../upsertChannelRequestViewModelSchema.ts";

export const putApiV1CourseCourseidChannelsChannelidPathParamsSchema = z.object(
  {
    courseId: z.coerce.number().int(),
    channelId: z.coerce.number().int(),
  },
) as unknown as ToZod<PutApiV1CourseCourseidChannelsChannelidPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1CourseCourseidChannelsChannelid200Schema = z.lazy(
  () => channelDetailViewModelSchema,
) as unknown as ToZod<PutApiV1CourseCourseidChannelsChannelid200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1CourseCourseidChannelsChannelid400Schema =
  z.any() as unknown as ToZod<PutApiV1CourseCourseidChannelsChannelid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1CourseCourseidChannelsChannelid401Schema =
  z.any() as unknown as ToZod<PutApiV1CourseCourseidChannelsChannelid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1CourseCourseidChannelsChannelid404Schema =
  z.any() as unknown as ToZod<PutApiV1CourseCourseidChannelsChannelid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1CourseCourseidChannelsChannelid500Schema =
  z.any() as unknown as ToZod<PutApiV1CourseCourseidChannelsChannelid500>;

export const putApiV1CourseCourseidChannelsChannelidMutationRequestSchema =
  z.lazy(
    () => upsertChannelRequestViewModelSchema,
  ) as unknown as ToZod<PutApiV1CourseCourseidChannelsChannelidMutationRequest>;

export const putApiV1CourseCourseidChannelsChannelidMutationResponseSchema =
  z.lazy(
    () => putApiV1CourseCourseidChannelsChannelid200Schema,
  ) as unknown as ToZod<PutApiV1CourseCourseidChannelsChannelidMutationResponse>;
